import React from 'react';
import { Icon } from "semantic-ui-react";

function TheIcon (props) {
  return <Icon name="object group outline" {...props} />;
}

export const meta = {
  id: 'DataStructures',
  title: 'DataStructures',
  category: 'Engineering',
  exposes: [
    {
      title: 'Data Structure',
      action: { module: 'DataStructures', props: { /* */ } },
    },
    {
      title: 'New Data Structure',
      action: { module: 'DataStructuresDetails', props: { context: 'add' } },
    },
    {
      title: 'Diagram',
      action: { module: 'DataStructuresMapViewer', props: { /* */ } },
      desription: 'general-desc',
    },
  ],
  unique: true,
  icon: TheIcon,
  version: '1.0.0',
  description: `Manage data structures to be used throughout modules`,
  windowOptions: {
    // if not passed, will be centered
    // x: null,
    // y: null,
    // width: 630,
    // height: 380
  }
};
